var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pdf-templates-page"}},[_c('Header'),_c('PdfTemplatesTable',{attrs:{"templates":_vm.templates},on:{"updated":_vm.initialize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }